import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { OnsetExamDataDto } from 'src/shared/dtos/onset-exam-data-dto';
import { OnsetExamResultDto } from 'src/shared/dtos/onset-exam-result-dto';
import { OnsetUserDto } from 'src/shared/dtos/onset-user-dto';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ConnectorService {
    @Output() getOnsetExamDataCompleted: EventEmitter<OnsetExamDataDto> = new EventEmitter<OnsetUserDto>();
    @Output() postOnsetExamResultCompleted: EventEmitter<OnsetExamResultDto> = new EventEmitter<OnsetExamResultDto>();

    constructor(private httpClient: HttpClient) { }

    getOnsetExamData(token: string, env?: string) {
        let envParam = '';
        if(env && (env === 'staging' || env === 'develop')){
            envParam = `/?env=${env}`;
        }

        this.httpClient
            .get<OnsetExamDataDto>(environment.apiUrl + 'connector' + '/' + 'onset' + '/' + token + envParam)
            .subscribe((res: OnsetExamDataDto) => { this.getOnsetExamDataCompleted.emit(res); },
                (err: HttpErrorResponse) => {
                    console.log(err.error);
                    console.log(err.name);
                    console.log(err.message);
                    console.log(err.status);
                    this.getOnsetExamDataCompleted.emit(null);
                });
    }

    postOnsetExamResult(token: string, onsetExamResultDto: OnsetExamResultDto, env?: string) {
        let envParam = '';
        if(env && (env === 'staging' || env === 'develop')){
            envParam = `/?env=${env}`;
        }
        this.httpClient
            .post<OnsetExamResultDto>(environment.apiUrl + 'connector' + '/' + 'onset' + '/' + token + '/' + 'results' + envParam, onsetExamResultDto)
            .subscribe((res: OnsetExamResultDto) => { this.postOnsetExamResultCompleted.emit(res); },
                (err: HttpErrorResponse) => {
                    console.log(err.error);
                    console.log(err.name);
                    console.log(err.message);
                    console.log(err.status);
                });
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error);
            console.log(`${operation} failed: ${error.message}`);
            return of(result as T);
        };
    }
}

